<template>
  <div class="breadcrumb">
    <img src="../assets/home.png" alt="" width="20">
    <router-link to="/" class="pointer">{{$t('home')}}</router-link>
    <span class="separator">></span>
    <router-link :to="sedPath"  class="pointer">{{ $route.meta.title }}</router-link>
    <span v-if="isDetail" class="separator">></span>
    <span v-if="isDetail">{{$t('inside_pages')}}</span>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data() {
    return {
      isDetail:false,
      sedPath:''
    }
  },
  watch: { 
    $route: {
      handler(newRoute) {
        console.log(newRoute);
        const arr = newRoute.path.split("/")
        if(arr.length === 3) {
          this.isDetail = true
        }else {
          this.isDetail = false
        }
        this.sedPath = '/' + arr?.[1]
      },
      // 深度监听
      deep: true,
      immediate:true,
    }
  },
  computed: {
    secondLevelPath() {
      if (this.$route.name === 'newsDetail') {
        return { name: 'news' };
      }
      return this.$route.path;
    },
    showThirdLevel() {
      return this.$route.name === 'newsDetail';
    },
  }
}
</script>

<style scoped lang="scss">
.breadcrumb {
  padding: 190px 9vw 0;
  background: #063793;
  border-radius: 4px;
  line-height: 20px;
  font-weight: 300;
  font-size: 16px;
  color: #FEFEFE;
  display: flex;
  align-items: center;
  img {
    margin-right: 4px;
  }
}
.pointer {
  cursor: pointer;
}
.breadcrumb router-link {
  color: #337ab7;
  text-decoration: none;
}
.breadcrumb router-link:hover {
  text-decoration: underline;
}
.separator {
  margin: 0 5px;
  color: #ccc;
}
</style>  